<template>
  <svg :width="size" :height="Number(size) + 2" viewBox="0 0 6 8" :fill="color" xmlns="http://www.w3.org/2000/svg" class="pause">
    <path
      d="M1.125 0.625C1.42337 0.625 1.70952 0.743526 1.9205 0.954505C2.13147 1.16548 2.25 1.45163 2.25 1.75V6.25C2.25 6.54837 2.13147 6.83452 1.9205 7.0455C1.70952 7.25647 1.42337 7.375 1.125 7.375C0.826631 7.375 0.540483 7.25647 0.329505 7.0455C0.118526 6.83452 6.28765e-09 6.54837 0 6.25V1.75C0 1.45163 0.118526 1.16548 0.329505 0.954505C0.540483 0.743526 0.826631 0.625 1.125 0.625ZM4.875 0.625C5.17337 0.625 5.45952 0.743526 5.6705 0.954505C5.88147 1.16548 6 1.45163 6 1.75V6.25C6 6.54837 5.88147 6.83452 5.6705 7.0455C5.45952 7.25647 5.17337 7.375 4.875 7.375C4.57663 7.375 4.29048 7.25647 4.0795 7.0455C3.86853 6.83452 3.75 6.54837 3.75 6.25V1.75C3.75 1.45163 3.86853 1.16548 4.0795 0.954505C4.29048 0.743526 4.57663 0.625 4.875 0.625Z"
      :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#242424',
    },
    size: {
      type: String,
      default: 6,
    },

    hoverColor: {
      type: String,
      default: '#8869fd',
    },
  },
};
</script>

<style scoped>
.pause {
    transition: fill 0.3s ease;
    fill: v-bind(color);
}

.pause:hover path {
    fill: v-bind(hoverColor);
}
</style>
